import { useMemo, useState } from 'react'
import { FiExternalLink, FiHelpCircle, FiMail } from 'react-icons/fi'
import { MenuDropdown, MenuDropdownItem } from '~/@/components/inputs/selection/menu-dropdown'
import config from '~/common/config/config'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { SendEmailDialog } from '../shared/SendEmailDialog'

export const HelpPopover = () => {
  const { t } = useTypedTranslation()
  const { user } = useGlobalContext()
  const [openEmailDialog, setOpenEmailDialog] = useState(false)

  const emailBodyAdmin = user
    ? `${t('email_body_admin.admin_details')}
- ${t('email_body_admin.requested_by')} ${user.firstName} ${user.lastName} (${user.email})
- ${t('email_body_admin.organization_id')} ${user.organizationId}
- ${t('email_body_admin.url')} ${typeof window !== 'undefined' ? window.location.href : ''}`
    : ''

  const menuItems: MenuDropdownItem[] = useMemo(
    () => [
      {
        label: t('left_nav.contact_support'),
        icon: <FiMail className="text-base" />,
        onClick: () => setOpenEmailDialog(true),
      },
      { separator: true, label: '' },
      {
        label: t('left_nav.doss_docs'),
        icon: <FiExternalLink className="text-base" />,
        href: 'https://docs.doss.com',
        external: true,
      },
    ],
    [t],
  )

  return (
    <>
      <MenuDropdown
        align="end"
        items={menuItems}
        menuClassName="w-48"
        side="right"
        sideOffset={-4}
        trigger={
          <div className="flex size-6 cursor-pointer items-center justify-center rounded text-gray-11 hover:bg-black/[0.07] hover:text-gray-12">
            <FiHelpCircle size={16} />
          </div>
        }
      />
      {user && (
        <SendEmailDialog
          defaultBody={t('send_email_dialog.default_body')}
          defaultSubject={`[${user.organizationName}] ${t('send_email_dialog.default_subject')}`}
          defaultTo={config.supportEmail}
          emailBodyAdmin={emailBodyAdmin}
          onClose={() => setOpenEmailDialog(false)}
          open={openEmailDialog}
          title={t('send_email_dialog.title')}
        />
      )}
    </>
  )
}
